
// 
// -----------------------------------------------------------------------------
(function ($triangle) {
	if ($triangle.length === 0) {return false;}

	var $triangleWrap = $triangle.find('.triangle-wrap');
	var bounding = $triangle[0].getBoundingClientRect();

	    if (matchMedia) {
	      var mq = window.matchMedia("(min-width: 992px)");
	      mq.addListener(WidthChange);
	      WidthChange(mq);
	    }

	    function WidthChange(mq) {

	      if (mq.matches) {


			$triangle.on('mousemove', function(e){

	      	bounding = $triangle[0].getBoundingClientRect();

				if(e.clientX < bounding.width / 2 ){

					if( e.clientY - bounding.top < bounding.height - (( e.clientX ) / ( ( bounding.width / 2) / bounding.height)) ){
							$triangleWrap.addClass('on-left');

					}else{
						$triangleWrap.removeClass('on-left');
					}

				}else{
					$triangleWrap.removeClass('on-right');
					if( e.clientY - bounding.top < ( e.clientX - ( bounding.width / 2) ) / ( ( bounding.width / 2) / bounding.height) ){
						$triangleWrap.addClass('on-right');
						
					} else{
						$triangleWrap.removeClass('on-right');
					}
				}

			});

			$triangle.on('click', function(e){

					if( e.clientY - bounding.top < bounding.height - (( e.clientX ) / ( ( bounding.width / 2) / bounding.height)) ){

						var leftUrl = $('.left-url').data('left');		

						window.location = leftUrl;
						
					}else{
						
						if( e.clientY - bounding.top < ( e.clientX - ( bounding.width / 2) ) / ( ( bounding.width / 2) / bounding.height) ){

							var rightUrl = $('.right-url').data('right');				
							window.location = rightUrl;

						} 
				}

			});

			$triangle.mouseout(function(){
				$triangleWrap.removeClass('on-left');
				$triangleWrap.removeClass('on-right');
			});


		  } 

		}


})($( '.h-triangles' ));